import {AxiosError} from 'axios';
//interface
import {IErrorResponse} from '../types/error.interface';

export const getErrorResponse = (error: AxiosError<IErrorResponse>): IErrorResponse | undefined =>
	(error.response?.data || error?.response || error) as IErrorResponse | undefined;

export const getErrorMessage = (error: AxiosError<IErrorResponse>): string => {
	const errorResponse: IErrorResponse | undefined = getErrorResponse(error);
	return errorResponse?.detail || errorResponse?.title || errorResponse?.statusText || (error as unknown as string);
};
